module.exports = __webpack_public_path__ + "static/media/Bookmarks.9f808b73.svg";